import { cn } from '@reflex/ui/lib/utils';

interface CountBadgeProps {
  count: number;
  className?: string;
  'data-testid'?: string;
}

/**
 * The standard number badge for a control that carries a count — the same
 * treatment as the filter bar's active-filter count, so "N selected" reads
 * identically wherever it appears instead of each surface writing its own
 * freeform "with N" copy.
 */
export function CountBadge({ count, className, 'data-testid': testId }: CountBadgeProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'min-w-3.5 rounded-sm bg-ring/25 px-1 text-center text-2xs font-medium tabular-nums text-foreground',
        className,
      )}
    >
      {count}
    </span>
  );
}
